import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, SearchField, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

interface Props {
  attachableId: number
  schema: Schema
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  canAddValues: boolean
  canManage: boolean
}

const OptionsComponent = ({ schema, search, onSearch, canAddValues, canManage }: Props) => {
  const { navigation } = useNavigation()

  const [open, toggle] = useToggle()
  const rootRoute = React.useContext(RouteContext)
  const navigate = useNavigate()

  if (!rootRoute) return null

  const redirectToSettings = () => {
    navigate(navigation.settings.customizations.customTablesId.fullPath({ id: schema.id }))
  }

  const options = [
    {
      title: i18n.t('custom_tables.action'),
      onClick: redirectToSettings,
    },
  ]

  const newModalRoute = rootRoute.customTablesNew(schema.attributes.id)

  return (
    <>
      <Box flexGrow>
        <SearchField
          variant="big"
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('common.search')}
        />
      </Box>
      <Box flexDirection="row" gap="s8">
        {canAddValues && (
          <Button.Router to={newModalRoute} type="secondary">
            {i18n.t('custom_tables.add_value')}
          </Button.Router>
        )}
        {canManage && (
          <Popover
            attachment="top right"
            targetAttachment="bottom center"
            toggle={toggle}
            open={open}
          >
            <Button onClick={toggle(true)} type="secondary" iconName="ellipsis" />
            <PopoverContent onClose={toggle(false)} options={options} />
          </Popover>
        )}
      </Box>
    </>
  )
}

export default observer(OptionsComponent)
